<div class="p-grid" style="margin-bottom: 10px;">
    <div class="p-col p-p-0">
        <ng-container *ngFor="let col of column1">
            <div *ngIf="col.ischecked && data && col.field != 'address'"
                class="p-mb-1 p-d-flex border-bottom p-p-2 detail-row">
                <div style="width: 25%;">
                    <strong pTooltip="{{col.onhover ? col.onhover :  col.labelname }}" tooltipPosition="top">{{col.labelname}}</strong>
                </div>
                <span style="width: 75%;" [class.popup-opener]="moduleName !== 'Vendor' && linkFields.includes(col.field)"
                    (click)="setDetailsPopupData(col.field)">
                    <ng-container *ngIf="['twitter','website','other','facebook','linkedin','instagram', 'social', 'contactsocialtwitter',
                        'contactsocialwebsite','contactsocialfacebook', 'contactsociallinkedin','contactsocialinstagram']
                        .indexOf(col.field) >= 0; else elseData">
                        <a href="{{data[col.field] | url}}" target="_blank">{{data[col.field] | shorten }}</a>
                    </ng-container>
                    <ng-template #elseData>
                        <div [hidden]="col.field == 'attachmentLinks' || col.field == 'QOH'
                        || col.field == 'availabel' || col.field == 'onorder' ||  field == 'backorder' || col.field == 'onso'
                        || col.field == 'committed' || col.field == 'availtopick' || col.field == 'onpo' || col.field == 'returnqty'
                        || col.field == 'shipqty'" style="word-break: break-all;">
                         <span *ngIf="col.field === 'phone'">
                            {{data[col.field] | phoneNumber: data['code']}}
                        </span>
                        <span *ngIf="phoneFields.includes(col.field)" pTooltip="{{data[col.field]}}" style="white-space: pre-line;word-break: break-all;" tooltipPosition="top">
                            {{ data[col.field] | phoneNumber: data[col.field+'Code'] }}
                        </span>
                            <span *ngIf="col.field !== 'phone' && !phoneFields.includes(col.field)"  pTooltip="{{data[col.field]}}" tooltipPosition="top"
                            [ngClass]="{'report-link': col.field === 'warehouseName' }"
                            (click)="col.field === 'warehouseName' ?
                           detailsView(data,col.field === 'warehouseName' ? 'warehouseName': '') : null">
                                {{data[col.field] | shorten: 100}}
                            </span>
                            <span *ngIf="moduleName==objectNames.WORKFLOW && col.field === 'createdDate' && data?.createdByUserName" class="p-ml-1">
                                <i class="pi pi-info-circle" pTooltip="{{'Created By: '+ data?.createdByUserName}}" tooltipPosition="top"></i>
                            </span>
                            <span *ngIf="moduleName==objectNames.WORKFLOW && col.field === 'lastUpdated' && data?.lastUpdatedByUserName" class="p-ml-1">
                                <i class="pi pi-info-circle" pTooltip="{{'Last Updated By: '+ data?.lastUpdatedByUserName}}" tooltipPosition="top"></i>
                            </span>
                        </div>
                        <div *ngIf="col.field == 'attachmentLinks'">
                            <div *ngFor="let file of data[col.field]" class="pointer">
                                <a (click)="openFilePreview(file)">
                                    {{ file.name | shorten: 30}}
                                </a>
                            </div>
                        </div>
                        <div *ngIf="col.field == 'QOH' || col.field == 'availabel' || col.field == 'onorder' || col.field == 'backorder'
                        || col.field == 'onso' || col.field == 'committed' || col.field == 'availtopick' || col.field == 'onpo'
                        || col.field == 'returnqty' || col.field == 'shipqty'">
                            <div class="pointer" *ngIf="data[col.field]>0">
                                <a  tooltipPosition="top">
                                    {{data[col.field] | shorten: 100}}
                                </a>
                            </div>
                            <div class="pointer" *ngIf="data[col.field]<0">
                                <a  tooltipPosition="top">
                                    {{data[col.field] | shorten: 100}}
                                </a>
                            </div>
                            <div *ngIf="data[col.field]==0">
                                {{data[col.field] | shorten: 100}}
                             </div>
                        </div>
                    </ng-template>
                </span>
                <span *ngIf="moduleName==objectNames.LEADS && col.field === 'currentStage' && data.isConvertedToAccount && data.leadStageId == qualifiedId">*</span>

            </div>
        </ng-container>
        <div *ngIf="column1Address" class="p-mb-1 p-d-flex border-bottom p-p-2 detail-row">
            <div style="width: 25%;"><strong>{{column1Address.labelname}}</strong></div>
            <div style="width: 75%;">
                <p *ngIf="data && data['streetAddress1']" class="p-mb-0">{{data['streetAddress1']}},</p>
                <p *ngIf="data && data['streetAddress2']" class="p-mb-0">{{data['streetAddress2']}},</p>
                <p *ngIf="data && data['cityStateCountry']" class="p-mb-0">{{data['cityStateCountry']}}</p>
            </div>
        </div>
    </div>

    <p-divider *ngIf="column2.length" layout="vertical"></p-divider>

    <div *ngIf="column2.length" class="p-col p-p-0">
        <ng-container *ngFor="let col of column2">
            <div *ngIf="col.ischecked && data && col.field != 'address'"
                class="p-mb-1 p-d-flex border-bottom p-p-2 detail-row">
                <div style="width: 25%;">
                    <strong pTooltip="{{col.onhover ? col.onhover :  col.labelname }}" tooltipPosition="top">{{col.labelname}}</strong>
                </div>
                <span style="width: 75%;" [class.popup-opener]="moduleName !== 'Vendor' && linkFields.includes(col.field)"
                    (click)="setDetailsPopupData(col.field)">
                    <ng-container *ngIf="['twitter','website','other','facebook','linkedin','instagram','social', 'contactsocialtwitter',
                        'contactsocialwebsite','contactsocialfacebook', 'contactsociallinkedin','contactsocialinstagram']
                        .indexOf(col.field) >= 0; else elseData">
                        <a href="{{data[col.field] | url}}" target="_blank">{{data[col.field] | shorten }}</a>
                    </ng-container>
                    <ng-template #elseData>
                        <span *ngIf="col.field === 'phone'">
                            {{data[col.field] | phoneNumber: data['code']}}
                        </span>
                        <span *ngIf="phoneFields.includes(col.field)" pTooltip="{{data[col.field]}}" style="white-space: pre-line;word-break: break-all;" tooltipPosition="top">
                            {{ data[col.field] | phoneNumber: data[col.field+'Code'] }}
                        </span>
                        <div *ngIf="col.field !== 'phone' && !phoneFields.includes(col.field)" [hidden]="col.field == 'attachmentLinks' || col.field == 'QOH'
                        || col.field == 'availabel' || col.field == 'onorder' || col.field == 'backorder'  || col.field == 'onso'
                        || col.field == 'committed' || col.field == 'availtopick' || col.field == 'onpo' || col.field == 'returnqty'
                        || col.field == 'shipqty'">
                            <span pTooltip="{{data[col.field]}}" tooltipPosition="top" 
                            [ngClass]="{'report-link': col.field === 'warehouseName' }"
                            (click)="col.field === 'warehouseName' ?
                           detailsView(data,col.field === 'warehouseName' ? 'warehouseName': '') : null">
                                {{data[col.field] | shorten: 100}}
                            </span>
                        </div>
                        <div *ngIf="col.field == 'attachmentLinks'" class="pointer">
                            <div *ngFor="let file of data[col.field]">
                                <a (click)="openFilePreview(file)">
                                    {{ file.name | shorten: 30}}
                                </a>
                            </div>
                        </div>
                        <div *ngIf="col.field == 'QOH' || col.field == 'availabel' || col.field == 'onorder' || col.field == 'backorder'
                        || col.field == 'onso' || col.field == 'committed' || col.field == 'availtopick' || col.field == 'onpo'
                        || col.field == 'returnqty' || col.field == 'shipqty'">
                            <div class="pointer" *ngIf="data[col.field]>0">
                                <a tooltipPosition="top">
                                    {{data[col.field] | shorten: 100}}
                                </a>
                            </div>
                            <div class="pointer" *ngIf="data[col.field]<0">
                                <a tooltipPosition="top">
                                    {{data[col.field] | shorten: 100}}
                                </a>
                            </div>
                            <div *ngIf="data[col.field]==0">
                                    {{data[col.field] | shorten: 100}}
                            </div>
                        </div>
                    </ng-template>
                </span>
                <span *ngIf="moduleName==objectNames.LEADS && col.field === 'currentStage' && data.isConvertedToAccount
                && data.leadStageId == qualifiedId">*</span>
            </div>
        </ng-container>
        <div *ngIf="column2Address" class="p-mb-1 p-d-flex border-bottom p-p-2 detail-row">
            <div style="width: 25%;"><strong>{{column2Address.labelname}}</strong></div>
            <div style="width: 75%;">
                <p *ngIf="data && data['streetAddress1']" class="p-mb-0">{{data['streetAddress1']}},</p>
                <p *ngIf="data && data['streetAddress2']" class="p-mb-0">{{data['streetAddress2']}},</p>
                <p *ngIf="data && data['cityStateCountry']" class="p-mb-0">{{data['cityStateCountry']}}</p>
            </div>
        </div>
    </div>

    <p-divider *ngIf="moduleName == 'Opportunity'" layout="vertical"></p-divider>

    <div class="p-col-3 p-p-0 no-shadow" *ngIf="moduleName == 'Opportunity'">
        <p-card [style]="{'width': '100%'}">
            <h6 class="p-pb-3 p-mb-0" style="border-bottom: 1px solid #eee;">{{scoreName}}
                <span class="pi pi-info-circle" pTooltip="{{scoreToolTip ?? ''}}" tooltipPosition="top"></span>
            </h6>
            <div class="p-grid p-mt-4">
                <div class="p-col-5">
                    <p-skeleton *ngIf="!opportunityMLAIScore" width="6rem" height="3rem" borderRadius="16px"></p-skeleton>
                    <h1 style="color: var(--primary-color);" *ngIf="opportunityMLAIScore">
                        {{opportunityMLAIScore?.score == 0? 'N/A' : opportunityMLAIScore?.score}}
                    </h1>
                </div>
                <div class="p-col-7">
                    <p-skeleton *ngIf="!opportunityMLAIScore" width="6rem" height="1rem" borderRadius="16px"></p-skeleton>
                    <h6 class="p-ml-3 p-mb-2" *ngIf="opportunityMLAIScore">Grade - {{opportunityMLAIScore?.grade == null? 'N/A' : opportunityMLAIScore?.grade}}
                        <span class="pi pi-info-circle" pTooltip="{{gradeToolTip ?? ''}}" tooltipPosition="top"></span>
                    </h6>
                    <div class="p-d-flex">
                        <p-skeleton *ngIf="!opportunityMLAIScore" width="8rem" height="2rem" borderRadius="16px" [style]="{'margin-top': '25px'}"></p-skeleton>
                        <span *ngIf="opportunityMLAIScore">
                            <img alt="opportunityScore"
                            [src]="assestBaseUrl + 'ai-images/' + opportunityMLAIScore?.graphIconName" 
                                style="max-width:80px; max-height:40px" />
                            <span style="position:absolute; padding:7px;">
                                {{opportunityMLAIScore?.differenceFromLastScoreText}}
                            </span>
                        </span>
                    </div>
                </div>
            </div>
            <ng-template pTemplate="footer">
                <div class="p-d-flex p-jc-between">
                    <p-skeleton *ngIf="!opportunityMLAIScore" width="13rem" height="1rem" borderRadius="16px"></p-skeleton>
                    <p *ngIf="opportunityMLAIScore">Last Updated: {{opportunityMLAIScore?.lastUpdatedDate == null ? '' : opportunityMLAIScore?.lastUpdatedDate | dateAsAgoWithTimezone}}
                    </p>
                </div>
            </ng-template>
        </p-card>
    </div>
</div>

<app-shared-detail-popup *ngIf="displayDetailPopup" [moduleType]="moduleType" [currentDisplay]="displayDetailPopup"
    [dataId]="dataId" [associationTypeId]="associationTypeId" [header]="popupHeader" [column]="popUpColumns" (dialogClosed)="closeDialog()">
</app-shared-detail-popup>

<p-toast position="top-right" [baseZIndex]="10000"></p-toast>

<!-- File Opener Modal -->
<app-shared-file-opener *ngIf="displayFilePreview" [modalDisplay]="displayFilePreview" [modalFile]="currentFile"
    (closeFilePreview)="closeFilePreview()">
</app-shared-file-opener>



